import Nav from "../Nav";
import { Link } from "react-router-dom";
import Head from "../Head";
import Carousel from "../Carousel";

export const Fotogramas = () => {
  var settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
        },
      },
    ],
  };
  return (
    <>
      <Head title="Proyectos - Fotogramas botánicos" />
      <Nav titulo="Fotogramas botánicos" link="/proyectos" />
      <section
        id="about_me"
        className="mb-5 animate__fadeInDown wow animate__animated animate__delay-0s animate__slower"
      >
        <div className="container-fluid overflow-hidden">
          <div className="row marMob">
            <h3 className="text-center text-md-start fs-6">
              <i className="bi bi-flower3"></i> Revelados con romero, papa,
              orégano y tomillo
            </h3>
            <hr />
            <div className="col-md-6 img-fluid  p-md-4 p-1">
                <Carousel settings={settings}>
                  <img
                    src="../img/fotogramas/fotogramas_botanicos (1).jpg"
                    className="img-fluid"
                    alt="fotolibro"
                  />
                  <img
                    src="../img/fotogramas/fotogramas_botanicos (2).jpg"
                    className="img-fluid"
                    alt="fotolibro"
                  />
                  <img
                    src="../img/fotogramas/fotogramas_botanicos (3).jpg"
                    className="img-fluid"
                    alt="fotolibro"
                  />
                  <img
                    src="../img/fotogramas/fotogramas_botanicos (4).jpg"
                    className="img-fluid"
                    alt="fotolibro"
                  />
                </Carousel>
              </div>
            <p className="col-md-6 ">
              Fotogramas botánicos realizados a partir de elementos naturales
              que nos rodean y revelados a través de fórmulas no contaminantes.
              Los reveladores utilizados para traer la imagen latente en el
              papel son: romero, papa, orégano y tomillo.{" "}
            </p>
          </div>
          <div className="reverse row marMob">
            <p className="col-md-6 ">
              El proceso de creación de fotogramas es una técnica fotográfica
              que consiste propiamente en colocar un material opaco o
              semitransparente sobre un soporte fotosensible, exponerlo a la
              acción de la luz y posteriormente transformarlo químicamente en un
              material permanente.{" "}
            </p>
            <div className="col-md-6 img-fluid  p-md-4 p-1">
                <Carousel settings={settings}>
                  <img
                    src="../img/fotogramas/fotogramas_botanicos (5).jpg"
                    className="img-fluid"
                    alt="fotolibro"
                  />
                  <img
                    src="../img/fotogramas/fotogramas_botanicos (6).jpg"
                    className="img-fluid"
                    alt="fotolibro"
                  />
                  <img
                    src="../img/fotogramas/fotogramas_botanicos (7).jpg"
                    className="img-fluid"
                    alt="fotolibro"
                  />
                  <img
                    src="../img/fotogramas/fotogramas_botanicos (8).jpg"
                    className="img-fluid"
                    alt="fotolibro"
                  />
                  <img
                    src="../img/fotogramas/fotogramas_botanicos (9).jpg"
                    className="img-fluid"
                    alt="fotolibro"
                  />
                </Carousel>
              </div>
          </div>
          <div className="row marMob">
          <div className="col-md-6 img-fluid  p-md-4 p-1">
                <Carousel settings={settings}>
                  <img
                    src="../img/fotogramas/fotogramas_botanicos (10).jpg"
                    className="img-fluid"
                    alt="fotolibro"
                  />
                  <img
                    src="../img/fotogramas/fotogramas_botanicos (11).jpg"
                    className="img-fluid"
                    alt="fotolibro"
                  />
                  <img
                    src="../img/fotogramas/fotogramas_botanicos (12).jpg"
                    className="img-fluid"
                    alt="fotolibro"
                  />
                  <img
                    src="../img/fotogramas/fotogramas_botanicos (13).jpg"
                    className="img-fluid"
                    alt="fotolibro"
                  />
                  <img
                    src="../img/fotogramas/fotogramas_botanicos (14).jpg"
                    className="img-fluid"
                    alt="fotolibro"
                  />
                </Carousel>
              </div>
            <p className="col-md-6 ">
              <i>
                *Este proyecto fue invitado para ser expuesto durante el SOPA
                2022: X congreso internacional de socialización en el medio
                rural, en el Museo de Ciencias Naturales Angel Gallardo de la
                ciudad de Rosario. La{" "}
                <Link to="/muestras/muestra_una_ramita" target={"_blanck"}>
                  <span className="violeta">muestra</span>
                </Link>{" "}
                fue inaugurada en el marco de la Noche de los Museos.
              </i>
            </p>
          </div>
        </div>
      </section>
    </>
  );
};
